import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("ErrorBoundary caught:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                    padding: "2rem",
                    textAlign: "center",
                    background: "#1a1a2e",
                    color: "#e0e0e0",
                }}>
                    <h1 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>
                        Bir hata oluştu
                    </h1>
                    <p style={{ color: "#aaa", marginBottom: "1.5rem" }}>
                        {this.state.error?.message || "Bilinmeyen bir hata oluştu."}
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: "0.75rem 1.5rem",
                            background: "#4a90d9",
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "1rem",
                        }}
                    >
                        Sayfayı Yenile
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
